module.exports = __webpack_public_path__ + "img/group_2.8ba98a01.png";